export class NoContentException extends Error {
  constructor() {
    super();
    this.name = 'NoContentException';
  }
}
